module.exports = __webpack_public_path__ + "media/images/home/step-delivery-7b75b6e7018edeaebabc099ed7ccfd90.png";